import { gsap } from 'gsap'; 

// const throttle = (fn, delay) => {
//   let timeout = false;
//   return (...rest) => {
//     if (!timeout) {
//       timeout = true;
//       fn.apply(this, rest);
//       setTimeout(() => {
//         timeout = false;
//       }, delay);
//     }
//   }
// }

const calcDist = (centre, mouseX, mouseY) => {
  return Math.floor(Math.sqrt(Math.pow(calcDistX(centre.x, mouseX), 2) + Math.pow(calcDistY(centre.y, mouseY), 2)));
}

const calcDistX = (x, mouseX) => {
  return mouseX - x;
}
const calcDistY = (y, mouseY) => {
  return mouseY - y;
}

// https://codepen.io/halfvillain/pen/LYGgaab
const cursorProximityMove = (trigger, disableAfterClick) => {

  // cgsap.set(trigger.querySelector('*'), {'pointerEvents': 'none'});
  trigger.addEventListener('mouseleave', out);

  trigger.addEventListener('mousemove', mouseMoveFunc);
  if (disableAfterClick == true){
    trigger.addEventListener('click', function(event){
      trigger.removeEventListener('mousemove', mouseMoveFunc);  
    });          
  }

  var moveMultiplier = 0.3;
  if (trigger.dataset.proximitymove) {
    moveMultiplier = trigger.dataset.proximitymove;
  }
  var moveDuration = 1;
  if (trigger.dataset.proximityduration) {
    moveDuration = trigger.dataset.proximityduration;
  } 

  function out() {
    if (trigger.dataset.proximityscale) {
      gsap.to(trigger, {
        scale: 1,
        x: 0,
        y: 0,
        ease: 'power3.out',
        duration: moveDuration
      });
    } else {
      gsap.to(trigger, {
        x: 0,
        y: 0,
        ease: 'power3.out',
        duration: moveDuration
      });      
    }
  };

  let mouseX, mouseY, boundingRect, boundingRectX, boundingRectY;
  document.addEventListener('mousemove', e => {    
      boundingRect = trigger.getBoundingClientRect();
      mouseX = e.clientX;
      mouseY = e.clientY; 
      boundingRectX = boundingRect.left+boundingRect.width/2;
      boundingRectY = boundingRect.top+boundingRect.height/2;
  });

  function mouseMoveFunc(e) {
    // window.addEventListener('scroll', () => {
    //   cursorY = e.pageY - window.pageYOffset;
    // });
    // window.addEventListener('mousemove', (e) => {
    //   cursorY = e.y;
    // });
    let distanceX = mouseX - boundingRectX;
    let distanceY = mouseY - boundingRectY;
    gsap.to(trigger, {
      x: distanceX*moveMultiplier,
      y: distanceY*moveMultiplier,
      duration: moveDuration
    }); 

  };
}

export { calcDist, calcDistX, calcDistY, cursorProximityMove };